import { render, staticRenderFns } from "./ApplicabilityTile.vue?vue&type=template&id=94fade40&scoped=true&"
import script from "./ApplicabilityTile.vue?vue&type=script&lang=ts&"
export * from "./ApplicabilityTile.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicabilityTile.vue?vue&type=style&index=0&id=94fade40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fade40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VProgressCircular})
